module.exports = __webpack_public_path__ + "img/bigdata.a3bfacb5.jpg";